import { CalendarBlank, Clock, MapPin } from '@phosphor-icons/react'
import KioskHeader from '../../components/KioskHeader/KioskHeader'
import useKioskAutoHome from '../../hooks/useKioskAutoHome'

const EVENTS = [
  { title: 'Community Meet & Greet', date: '12 Jun 2026', time: '10:00 AM', venue: 'Main Hall' },
  { title: 'Health Awareness Talk', date: '18 Jun 2026', time: '2:30 PM', venue: 'Multipurpose Room' },
  { title: 'Neighbourhood Clean-up Day', date: '25 Jun 2026', time: '8:00 AM', venue: 'Lobby Entrance' },
]

export default function EventsPage() {
  useKioskAutoHome()

  return (
    <main className="kiosk-page">
      <div className="app-container kiosk-container">
        <KioskHeader title="Events" subtitle="Upcoming community activities" />

        <section className="kiosk-section-card">
          <div className="kiosk-section-card__header">
            <CalendarBlank size={30} />
            <div>
              <h1>Upcoming Events</h1>
              <p>Stay updated with community programmes and announcements.</p>
            </div>
          </div>

          <div className="kiosk-list">
            {EVENTS.map((event) => (
              <article className="kiosk-list-card" key={event.title}>
                <strong>{event.title}</strong>
                <div><CalendarBlank size={18} /> {event.date}</div>
                <div><Clock size={18} /> {event.time}</div>
                <div><MapPin size={18} /> {event.venue}</div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </main>
  )
}
